import {
    usePostControlsNew,
    usePostControlsNewSuspense,
} from "api/generated/controls/controls";

interface NewControlQueryParams {
    controlProgramId?: number;
    controlTemplateId?: number;
    sourceControlId?: string;
}

export const useNewControlQuery = (
    params: NewControlQueryParams,
    enabled = true
) =>
    usePostControlsNew(
        {
            control_program_id: params.controlProgramId,
            control_template_id: params.controlTemplateId,
            source_control_id: params.sourceControlId,
        },
        {
            query: {
                select: (response) => response.data,
                enabled,
            },
        }
    );

export const useNewControlSuspenseQuery = () =>
    usePostControlsNewSuspense(undefined, {
        query: { select: (response) => response.data },
    });
